import React, { useEffect, useState } from 'react';
import { api } from '../api';

export function ProblemContactsPage() {
  const [type, setType] = useState('skorozvon');
  const [rows, setRows] = useState([]);
  const [reasons, setReasons] = useState([]);
  const [selectedReason, setSelectedReason] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [retryingId, setRetryingId] = useState(null);
  const [error, setError] = useState('');
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({ page: 1, pageSize: 50, total: 0, totalPages: 1 });

  function handleTypeChange(nextType) {
    if (nextType === type) return;
    setType(nextType);
    setRows([]);
    setReasons([]);
    setSelectedReason('');
    setPage(1);
    setPagination({ page: 1, pageSize: 50, total: 0, totalPages: 1 });
    setMessage('');
    setError('');
  }

  function handleReasonChange(nextReason) {
    setSelectedReason(nextReason);
    setPage(1);
  }

  async function load(currentType = type, currentPage = page, currentReason = selectedReason) {
    setLoading(true);
    setError('');
    try {
      const data = await api(`/problem-contacts?type=${currentType}&page=${currentPage}&pageSize=50&reason=${encodeURIComponent(currentReason || '')}`);
      setRows(data.items || []);
      setPagination(data.pagination || { page: 1, pageSize: 50, total: 0, totalPages: 1 });
    } catch (currentError) {
      setRows([]);
      throw currentError;
    } finally {
      setLoading(false);
    }
  }

  async function loadReasons(currentType = type) {
    try {
      setReasons(await api(`/problem-contacts/reasons?type=${currentType}`));
    } catch (_error) {
      setReasons([]);
    }
  }


  useEffect(() => {
    setRows([]);
    setReasons([]);
    Promise.all([
      load(type, 1, ''),
      loadReasons(type)
    ]).catch((currentError) => setError(currentError.message || 'Не удалось загрузить проблемные контакты'));
  }, [type]);

  useEffect(() => {
    load(type, page, selectedReason).catch((currentError) => setError(currentError.message || 'Не удалось загрузить проблемные контакты'));
  }, [page, selectedReason]);

  async function retry(id) {
    setMessage('');
    setError('');
    setRetryingId(id);
    try {
      await api(`/problem-contacts/${id}/retry`, { method: 'POST' });
      await load(type, page, selectedReason);
      setMessage('Повторный запуск выполнен');
    } finally {
      setRetryingId(null);
    }
  }

  return (
    <section className="card">
      {message ? <div className="success-banner section-banner">{message}</div> : null}
      {error ? <div className="error-banner section-banner">{error}</div> : null}
      <div className="section-header">
        <h2>Проблемные контакты</h2>
        <div className="tabs type-tabs">
          <button type="button" className={`filter-chip ${type === 'skorozvon' ? 'active' : ''}`} onClick={() => handleTypeChange('skorozvon')}>Скорозвон</button>
          <button type="button" className={`filter-chip ${type === 'bank' ? 'active' : ''}`} onClick={() => handleTypeChange('bank')}>Банк</button>
        </div>
        <div className="scope-tags reason-tags">
          <button
            type="button"
            className={`filter-chip ${!selectedReason ? 'active' : ''}`}
            onClick={() => handleReasonChange('')}
          >
            Все причины
          </button>
          {reasons.map((item) => (
            <button
              key={item.reason}
              type="button"
              className={`filter-chip ${selectedReason === item.reason ? 'active' : ''}`}
              onClick={() => handleReasonChange(item.reason)}
            >
              {item.reason} ({item.total})
            </button>
          ))}
        </div>
      </div>
      {loading ? <div className="muted">Загрузка...</div> : null}
      <table className="table">
        <thead><tr><th>ID</th><th>Интеграция</th><th>Операция</th><th>Контакт</th><th>Телефон</th><th>Файл</th><th>Причина</th><th>Статус</th><th></th></tr></thead>
        <tbody>
          {rows.map((item) => (
            <tr key={item.id}>
              <td>{item.id}</td>
              <td>{item.integration_type}</td>
              <td>{item.operation}</td>
              <td>{item.fio || item.company_name || '-'}</td>
              <td>{item.phone || '-'}</td>
              <td>{item.original_name || '-'}</td>
              <td>{item.reason}</td>
              <td>{item.status}</td>
              <td><button type="button" disabled={retryingId === item.id} onClick={() => retry(item.id).catch((currentError) => setError(currentError.message || 'Не удалось повторить операцию'))}>{retryingId === item.id ? 'Повтор...' : 'Повторить'}</button></td>
            </tr>
          ))}
          {!rows.length && !loading ? <tr><td colSpan="9">Проблемных контактов нет</td></tr> : null}
        </tbody>
      </table>
      <div className="pagination top-gap">
        <div className="pagination-controls">
          <button type="button" disabled={page <= 1 || loading} onClick={() => setPage((value) => Math.max(1, value - 1))}>Назад</button>
          <span className="pagination-info">Страница {pagination.page} из {pagination.totalPages}</span>
          <button type="button" disabled={page >= pagination.totalPages || loading} onClick={() => setPage((value) => Math.min(pagination.totalPages, value + 1))}>Вперёд</button>
        </div>
      </div>
    </section>
  );
}
